<app-header></app-header>
<main>
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
<error-popup></error-popup>
<!-- <loader-panel></loader-panel> -->
